export const NOTIFICATIONS_ALL = 'NOTIFICATIONS_ALL';
export const NOTIFICATIONS_ALL_SUCCESS = 'NOTIFICATIONS_ALL_SUCCESS';
export const NOTIFICATIONS_UNREAD = 'NOTIFICATIONS_UNREAD';
export const NOTIFICATIONS_UNREAD_SUCCESS = 'NOTIFICATIONS_UNREAD_SUCCESS';
export const NOTIFICATIONS_ALL_UNREAD = 'NOTIFICATIONS_ALL_UNREAD';
export const NOTIFICATIONS_ALL_UNREAD_SUCCESS =
  'NOTIFICATIONS_ALL_UNREAD_SUCCESS';
export const NOTIFICATIONS_GET = 'NOTIFICATIONS_GET';
export const NOTIFICATIONS_GET_SUCCESS = 'NOTIFICATIONS_GET_SUCCESS';
export const NOTIFICATIONS_MARK_READ = 'NOTIFICATIONS_MARK_READ';
export const NOTIFICATIONS_LAST = 'NOTIFICATIONS_LAST';
export const NOTIFICATIONS_LAST_SUCCESS = 'NOTIFICATIONS_LAST_SUCCESS';
